import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Injectable({
  providedIn: 'root',
})
export class PdfResumeCaseService {
  constructor() {}

  async getImageAsBase64(url) {
    return new Promise<string>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result as string);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = function () {
        reject('Error al cargar la imagen.');
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  async createPDF(data, info, iCase, task) {
    const imageUrl = await this.getImageAsBase64(
      'assets/images/logo_analytiko.png'
    );

    let pdfDefinition: any = {
      content: [
        {
          image: imageUrl,
          width: 220,
          height: 45,
          margin: [0, 0, 0, 15],
        },
        {
          text: `Resumen de Caso ${iCase.gai}`,
          style: 'header',
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 5,
              x2: 520, // Ancho de la línea
              y2: 5,
              lineWidth: 1, // Grosor de la línea
              lineColor: '#000000', // Color de la línea (código hexadecimal)
            },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          columns: info,
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
        },
        subheader: {
          fontSize: 15,
          bold: true,
        },
        quote: {
          italics: true,
        },
        small: {
          fontSize: 8,
        },
        tableStyle: {
          noWrap: true, // Evita que el texto se divida en varias líneas
          fontSize: 7,
        },
      },
    };
    for (let data of task) {
      pdfDefinition.content.push(data);
    }
    const pdf = pdfMake.createPdf(pdfDefinition);
    pdf.open();
  }
}
